import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

const events = ['mousedown', 'keydown', 'scroll', 'touchstart']

export default function HashJumper({ children }) {
  const location = useLocation()

  useLayoutEffect(() => {
    const elementId = location.hash.slice(1)
    if (!elementId) return

    events.forEach(event => document.addEventListener(event, stop))

    function stop() {
      events.forEach(event => document.removeEventListener(event, stop))
      observer.disconnect()
    }

    function findTarget() {
      const element = document.getElementById(elementId)
      if (!element) return
      element.scrollIntoView()
      stop()
    }

    const observer = new MutationObserver(() => {
      findTarget()
    })

    observer.observe(document, { childList: true, subtree: true })

    findTarget()

    return stop
  }, [location.hash])

  return children
}

HashJumper.propTypes = {
  children: PropTypes.node,
}
